module.exports = __webpack_public_path__ + "img/vips.a850b596.png";